import axios from 'axios/index'

const namespaced = true

const state = {
  isBusy: null,
  dealers: null,
  modalParamsDealer: null,
  dealerData: null,
  dealerPriceData: null,
  dealerClients: null,
  messagePricePositions: {
    api: [],
    spec_condition: []
  },
  dealerMinimalPrices: null,
  dealerSpecialPrices: null,
  dealerSpecCondition: null
}
const actions = {
  getDealers ({ commit }, data, isGroupsReload = true) {
    commit('busyState', isGroupsReload)
    return axios.get('/api/private/v3.0/dealers/?server_alias=' + data)
      .then(response => {
        commit('setDealers', response.data)
        commit('busyState', false)
      })
      .catch(error => {
        console.log(error)
        commit('busyState', false)
      })
  },
  getDealerModalParams ({ commit }, data) {
    return axios.get('/api/private/v3.0/dealers/' + data.id + '/')
      .then(response => {
        commit('setDealerModalParams', response.data)
      })
      .catch(error => {
        console.log(error)
      })
  },
  createDealer ({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      axios.post('/api/private/v3.0/dealers/', data)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  editDealer ({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      axios.patch('/api/private/v3.0/dealers/' + data.p_id + '/', data)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  saveDealerPrice (_, payload) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: `/api/private/v3.0/prices/${payload.billing_alias}/${payload.id}/`,
        data: payload.data
      })
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  updateDealerPrice (_, payload) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'PUT',
        url: `/api/private/v3.0/prices/${payload.billing_alias}/${payload.id}/`,
        data: payload.data
      })
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getDealerPricesData ({ commit }, data) {
    return axios.get('/api/private/v3.0/dealers/' + data.id + '/prices/')
      .then(response => {
        commit('setDealerData', response.data)
      })
      .catch(error => {
        console.log(error)
      })
  },
  getDealerPrice ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'GET',
        url: `/api/private/v3.0/prices/${payload.billing_alias}/${payload.id}/?year=${payload.year}&month=${payload.month}`
      })
        .then(response => {
          commit('setPrice', response.data)
          resolve()
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getDealerClients ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'GET',
        url: `/api/private/v3.0/dealers/${payload.id}/clients/`
      })
        .then(response => {
          commit('setDealerClients', response.data)
          resolve()
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getMessagePricePositions ({ commit }) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'GET',
        url: '/api/private/v3.0/billing/lists/message_price_positions/'
      })
        .then(response => {
          commit('setMessagePricePositions', response.data)
          resolve()
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  saveDealerSpecPrice (_, payload) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: `/api/private/v3.0/spec-prices/${payload.type}/`,
        data: payload.data
      })
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  updateDealerSpecPrice (_, payload) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'PUT',
        url: `/api/private/v3.0/spec-prices/${payload.type}/`,
        data: payload.data
      })
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getDealerSpecPrice ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'GET',
        url: `/api/private/v3.0/spec-prices/${payload.type}/?client_id=${payload.client_id}&year=${payload.year}&month=${payload.month}`
      })
        .then(response => {
          commit('setPrice', response.data)
          resolve()
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getDealerSpecialPrices ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'GET',
        url: `/api/private/v3.0/dealers/${payload.id}/spec-prices/`
      })
        .then(response => {
          commit('setDealerSpecialPrices', response.data)
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getDealerMinimalPrice ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'GET',
        url: `/api/private/v3.0/tariff-minimum/?dealer_org_id=${payload.dealer_org_id}&client_org_ids=${payload.client_org_id}`
      })
        .then(response => {
          commit('setPrice', response.data.results[0])
          resolve()
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  saveDealerMinimumPrice (_, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: '/api/private/v3.0/tariff-minimum/',
        data
      })
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  updateDealerMinimumPrice (_, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'PATCH',
        url: '/api/private/v3.0/tariff-minimum/',
        data
      })
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getDealerMinimalPrices ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'GET',
        url: `/api/private/v3.0/tariff-minimum/?dealer_org_id=${payload.org_id}`
      })
        .then(response => {
          commit('setDealerMinimalPrices', response.data)
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }
}
const mutations = {
  busyState (state, data) {
    state.isBusy = data
  },
  setDealers (state, data) {
    if (data) {
      state.dealers = data
    } else {
      state.dealers = []
    }
    state.isBusy = false
  },
  setDealerModalParams (state, data) {
    state.modalParamsDealer = data
  },
  setDealerData (state, data) {
    state.dealerData = data
  },
  setPrice (state, data) {
    state.dealerPriceData = data
  },
  setDealerClients (state, data) {
    data = data.map((item) => {
      item.label = item.name + ', ИНН: ' + item.inn
      return item
    })
    state.dealerClients = data
  },
  setMessagePricePositions (state, data) {
    data.spec_condition = data.spec_condition.map((item) => {
      item.label = item.caption
      item.id = item.alias
      return item
    })
    data.api = data.api.map((item) => {
      item.label = item.caption
      item.id = item.alias
      return item
    })
    state.messagePricePositions = data
  },
  setDealerSpecialPrices (state, data) {
    state.dealerSpecialPrices = data
  },
  setDealerMinimalPrices (state, data) {
    state.dealerMinimalPrices = data
  }
}

export default {
  namespaced,
  state,
  actions,
  mutations
}
